import { httpClient } from '~/utils/axios'
import { notifyError } from '~/utils/errorToast'
import { BILLING_CONFIRMATION_CODE } from '~/utils/clientBillingConfirmation'

export default ({ store, redirect, route }) => {
  httpClient.interceptors.request.use(
    config => {
      if (store.getters['auth/isLogin']) {
        config.headers = { Authorization: store.state.auth.authToken }
      }
      return config
    },
    error => {
      if (error.response && error.response.status === 500) {
        // ブラウザ標準 alert() はやめてエラートーストに（連続しても同じ文言は短時間に1回だけ）
        notifyError(store, '通信エラーが発生しました')
        return Promise.reject(error)
      }
    }
  )

  httpClient.interceptors.response.use(
    res => {
      // バージョン確認してローカルのAPIバージョンが古かったらバージョンアップ画面に飛ばす
      const current_api_version = process.env.API_VERSION
      console.log(
        'interceptors response',
        res.data.api_version,
        current_api_version
      )
      if (res.data.api_version && res.data.api_version > current_api_version) {
        if (route.path !== '/version_up/') redirect('/version_up/')
      }

      // レスポンスを見て処理を変更
      if (res.data.status === 'success') {
        return res
      } else {
        if (res.data.status === 'not_authenticated') store.commit('auth/logout')
        // 一括送信など、呼び出し側で失敗をまとめて通知するリクエストは1件ごとに出さない（config.suppressErrorAlert）
        // 次回課金日の確認を求める応答はエラーではない（呼び出し側がダイアログで聞く）。message は確認の流れを知らない開いたままの古い画面のために残っている
        const suppress =
          (res.config && res.config.suppressErrorAlert) ||
          res.data.code === BILLING_CONFIRMATION_CODE
        if (res.data.message && !suppress)
          store.commit('alert/setError', res.data.message)
        return res
      }
    },
    error => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error)
    }
  )
}
